import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataMessageModel } from '@core/model/dataMessage.model';

@Component({
  selector: 'app-modal-verification-email',
  templateUrl: './modal-verification-email.component.html',
  styleUrls: ['./modal-verification-email.component.scss']
})
export class ModalVerificationEmailComponent implements OnInit {
  icon: any;
  labelTitile: string;
  textDescription: any;
  textIndication: any;
  textLink: any;
  status: any;
  showResend: number;
  button = false;
  onResend = new EventEmitter();
  onAccept = new EventEmitter();

  constructor(@Inject(MAT_DIALOG_DATA) public dataMessage: DataMessageModel) {
    if (this.dataMessage !== null && this.dataMessage !== undefined) {
      this.labelTitile = this.dataMessage.labelTitile;
      this.icon = this.dataMessage.icon;
      this.textDescription = this.dataMessage.textDescription;
      this.textIndication = this.dataMessage.textIndication;
      this.textLink = this.dataMessage.textLink;
      this.status = this.dataMessage.status;
      this.showResend = this.dataMessage.showResend;
    } else {
      this.labelTitile = 'Lo sentimos parece que algo anda mal';
    }

  }

  ngOnInit() {
  }

  toAssign() {

  }

  accept() {
    this.onAccept.emit();
  }
  resend() {
    this.onResend.emit();
  }
}
